export function clearTopBarBg(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.removeProperty('--topBarBg');
}
